import { maskFieldProps, MasksKeysType } from "@/src/shared/utils/mask";
import { isNumber, isString, toString } from "lodash";
import { forwardRef } from "react";
import { IMaskInput } from "react-imask";



interface TextFieldMaskInputProps {
    onChange: (event: { target: { value: string } }) => void;
    value: string | number | undefined | null | { label: string; value: string }; 
    maskType: MasksKeysType;
    [key: string]: any;
  }

export const TextFieldMaskInput = forwardRef<HTMLInputElement, TextFieldMaskInputProps>((props, ref) => {
    const { onChange, value, maskType, ...other } = props;

    
    const maskConfig = maskFieldProps[maskType as MasksKeysType] || {};
    return (
      <IMaskInput
        {...other}
        inputRef={ref}
        value={(isString(value) ? value : isNumber(value) ? toString(value) : value?.value) ?? ''}
        {...maskConfig}
        onAccept={(_, maskInstance) => {
          const rawValue = maskInstance.unmaskedValue;
          onChange({ target: { value: rawValue } });
        }}
      />
    );
});

TextFieldMaskInput.displayName = 'TextFieldMaskInput';